export const DEFAULT_WEIGHT_KG = 70;

/**
 * Estimates calories using the ACSM running metabolic equation.
 * VO2 (ml/kg/min) = 3.5 + (speed_m_per_min * 0.2)
 * Calories/min   = MET * 3.5 * weight_kg / 200
 * Falls back to distance * weight * 1.036 when duration is unavailable.
 */
export function estimateCalories(distanceKm, durationStr, weightKg = DEFAULT_WEIGHT_KG) {
  if (!distanceKm || distanceKm <= 0) return 0;

  const weight = weightKg > 0 ? weightKg : DEFAULT_WEIGHT_KG;

  if (durationStr) {
    const parts = String(durationStr).split(':').map(Number);
    let hours = 0;
    if (parts.length === 3) hours = parts[0] + parts[1] / 60 + parts[2] / 3600;
    else if (parts.length === 2) hours = parts[0] / 60 + parts[1] / 3600;

    if (hours > 0) {
      const speedMPerMin = (distanceKm * 1000) / (hours * 60);
      const vo2 = 3.5 + speedMPerMin * 0.2;
      const met = vo2 / 3.5;
      const durationMin = hours * 60;
      return Math.round((met * 3.5 * weight) / 200 * durationMin);
    }
  }

  return Math.round(distanceKm * weight * 1.036);
}
